import { TOTALS_SUFFIX, COMPARE_PREFIX, COMPARE_SUFFIX } from '../constants';

export const getTotalsKey = (metric: string): string => `${metric}${TOTALS_SUFFIX}`;

export const getComparisonKey = (metric: string): string =>
  `${COMPARE_PREFIX}${metric}${COMPARE_SUFFIX}`;

export const getComparisonTotalsKey = (metric: string): string =>
  `${COMPARE_PREFIX}${metric}${COMPARE_SUFFIX}${TOTALS_SUFFIX}`;
